module.exports = __webpack_public_path__ + "static/media/accessoryImage.5e8ef618.png";